// extracted by mini-css-extract-plugin
module.exports = {"container":"_ae22a27b"};